<div  class='col-span-5 space-y-4 divide-y divide-base-300 h-full w-full'>
  <!-- Loading State -->
  <div *ngIf="smsTemplatesQuery.isLoading()" class="flex justify-center items-center py-12">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  </div>

  <!-- Error State -->
  <div *ngIf="smsTemplatesQuery.isError()" class="py-12 px-8">
    <div role="alert" class="alert alert-error">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 shrink-0 stroke-current" fill="none" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>Failed to load SMS templates. Please try refreshing the page.</span>
    </div>
  </div>

  <!-- Content - Only show when data is loaded -->
  <div *ngIf="smsTemplatesQuery.isSuccess() && smsTemplatesQuery.data()" class='grid grid-cols-6 gap-4 rounded-lg transition ease-out theme-hover-bg p-4'>
    <div>
      <div class='font-bold'>Booking Messages</div>
    </div>
    <div class='col-span-5 space-y-6'>
      <div class='grid grid-cols-4'>
        <div>
          <div class='font-semibold'>On Customer Booking Success</div>
        </div>
        <div class='col-span-2'>

          <nz-tabset>
            <nz-tab nzTitle='SMS Template'>
              <nz-mention [nzSuggestions]='bookingSuggestions'>
          <textarea
            nz-input
            [nzAutosize]='{ minRows: 4, maxRows: 4 }'
            [(ngModel)]='bookingMessageInput'
            (ngModelChange)='renderPreView()'
            nzMentionTrigger
          ></textarea>
              </nz-mention>
            </nz-tab>
            <nz-tab nzTitle='Preview'>
              <div [innerHTML]='bookingMessagePreview' class='font-mono font-semibold'></div>
            </nz-tab>
          </nz-tabset>


        </div>
        <div class='flex justify-end text-xl text-gray-500 cursor-pointer'>
          <div><span class='fe fe-edit-2 cursor-pointer'></span></div>
        </div>
      </div>
    </div>
  </div>

  <div class='grid grid-cols-6 gap-4 rounded-lg transition ease-out theme-hover-bg p-4'>
    <div>
      <div class='font-bold'>Parcel Messages</div>
    </div>
    <div class='col-span-5 space-y-8'>
      <div class='grid grid-cols-4'>
        <div>
          <div class='font-semibold'>On Collection</div>
        </div>
        <div class='col-span-2'>
          <nz-tabset>
            <nz-tab nzTitle='SMS Template'>
              <nz-mention [nzSuggestions]='parcelSuggestions'>
          <textarea
            nz-input
            [nzAutosize]='{ minRows: 4, maxRows: 4 }'
            [(ngModel)]='parcelCollectionMessageInput'
            (ngModelChange)='renderPreView()'
            nzMentionTrigger
          ></textarea>
              </nz-mention>
            </nz-tab>
            <nz-tab nzTitle='Preview'>
              <div [innerHTML]='parcelCollectionMessagePreview' class='font-mono font-semibold'></div>
            </nz-tab>
          </nz-tabset>
        </div>
        <div class='flex justify-end cursor-pointer text-xl text-gray-500'>
          <div><span class='fe fe-edit-2 '></span></div>
        </div>
      </div>

      <div class='grid grid-cols-4'>
        <div>
          <div class='font-semibold'>In Transit</div>
        </div>
        <div class='col-span-2'>
          <nz-tabset>
            <nz-tab nzTitle='SMS Template'>
              <nz-mention [nzSuggestions]='parcelSuggestions'>
          <textarea
            nz-input
            [nzAutosize]='{ minRows: 4, maxRows: 4 }'
            [(ngModel)]='parcelTransitMessageInput'
            (ngModelChange)='renderPreView()'
            nzMentionTrigger
          ></textarea>
              </nz-mention>
            </nz-tab>
            <nz-tab nzTitle='Preview'>
              <div [innerHTML]='parcelTransitMessagePreview' class='font-mono font-semibold'></div>
            </nz-tab>
          </nz-tabset>
        </div>
        <div class='flex justify-end cursor-pointer text-xl text-gray-500'>
          <div><span class='fe fe-edit-2 '></span></div>
        </div>
      </div>

      <div class='grid grid-cols-4'>
        <div>
          <div class='font-semibold'>Arrival</div>
        </div>
        <div class='col-span-2'>
          <nz-tabset>
            <nz-tab nzTitle='SMS Template'>
              <nz-mention [nzSuggestions]='parcelSuggestions'>
          <textarea
            nz-input
            [nzAutosize]='{ minRows: 4, maxRows: 4 }'
            [(ngModel)]='parcelArrivalMessageInput'
            (ngModelChange)='renderPreView()'
            nzMentionTrigger
          ></textarea>
              </nz-mention>
            </nz-tab>
            <nz-tab nzTitle='Preview'>
              <div [innerHTML]='parcelArrivalMessagePreview' class='font-mono font-semibold'></div>
            </nz-tab>
          </nz-tabset>
        </div>
        <div class='flex justify-end cursor-pointer text-xl text-gray-500'>
          <div><span class='fe fe-edit-2 '></span></div>
        </div>
      </div>

      <div class='grid grid-cols-4'>
        <div>
          <div class='font-semibold'>Delivered</div>
        </div>
        <div class='col-span-2'>
          <nz-tabset>
            <nz-tab nzTitle='SMS Template'>
              <nz-mention [nzSuggestions]='parcelSuggestions'>
          <textarea
            nz-input
            [nzAutosize]='{ minRows: 4, maxRows: 4 }'
            [(ngModel)]='parcelDeliveredMessageInput'
            (ngModelChange)='renderPreView()'
            nzMentionTrigger
          ></textarea>
              </nz-mention>
            </nz-tab>
            <nz-tab nzTitle='Preview'>
              <div [innerHTML]='parcelDeliveredMessagePreview' class='font-mono font-semibold'></div>
            </nz-tab>
          </nz-tabset>
        </div>
        <div class='flex justify-end cursor-pointer text-xl text-gray-500'>
          <div><span class='fe fe-edit-2 '></span></div>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="smsTemplatesQuery.isSuccess() && smsTemplatesQuery.data()" class='flex justify-center mt-2 pb-8 pt-8'>
    <button 
      class='btn btn-secondary btn-lg' 
      (click)='saveChanges()' 
      [disabled]="isSubmitting"
      [class.loading]="isSubmitting">
      {{ isSubmitting ? 'Saving...' : 'Save Changes' }}
    </button>
  </div>
</div>
